import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryManagedObjectsIds } from '@api/consistencyCheckParameters';

import { optionsFormattedWithArray } from '@utils/formatter';

import { TConsistencyCheckHistoryManagedIds } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_MANAGED_IDS } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryManagedObjectIds {
	consistencyCheckManagedObjectIds: TSelectOption<string>[];
	isLoadingConsistencyCheckManagedObjectIds: boolean;
	getConsistencyCheckBranchConfigIdsOptions:
		UseMutateFunction<any, any, TConsistencyCheckHistoryManagedIds, any>;
}

const useConsistencyCheckHistoryManagedObjectIds = (): IUseConsistencyCheckHistoryManagedObjectIds => {
	const {
		data,
		isLoading,
		mutate,
	} = useMutation<TConsistencyCheckHistoryManagedIds>({
		mutationKey: [CONSISTENCY_CHECK_HISTORY_MANAGED_IDS],
		mutationFn: getConsistencyCheckHistoryManagedObjectsIds,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	const options = optionsFormattedWithArray<string>(data || []);

	return {
		getConsistencyCheckBranchConfigIdsOptions: mutate,
		consistencyCheckManagedObjectIds: options,
		isLoadingConsistencyCheckManagedObjectIds: isLoading,
	};
};

export default useConsistencyCheckHistoryManagedObjectIds;
